// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import type DynamicTable from '@atlaskit/dynamic-table';
import StatusLozenge from '@atlassian/jira-common-components-status-lozenge/src/view.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { Issue } from '../../../services/issues/index.tsx';
import AssigneeCell from './assignee-cell/index.tsx';
import messages from './messages.tsx';
import SummaryCell from './summary-cell/index.tsx';

type TableHead = ComponentProps<typeof DynamicTable>['head'];
type TableRows = ComponentProps<typeof DynamicTable>['rows'];

export const useTableHead = (): TableHead => {
	const { formatMessage } = useIntl();
	return {
		cells: [
			{
				width: 55,
				key: 'issue',
				content: formatMessage(messages.issue),
			},
			{
				width: 25,
				key: 'assignee',
				content: formatMessage(messages.assignee),
			},
			{
				width: 20,
				key: 'status',
				content: formatMessage(messages.status),
			},
		],
	};
};

export const useTableRows = (issues: Issue[]): TableRows =>
	issues.map(({ key, summary, issueType, assignee, status }) => ({
		cells: [
			{
				key,
				content: (
					<SummaryCell issueKey={key} issueTypeIconUrl={issueType.iconUrl} summary={summary} />
				),
			},
			{
				key,
				content: <AssigneeCell assignee={assignee} />,
			},
			{
				key,
				content: <StatusLozenge name={status.name} category={status.category} />,
			},
		],
	}));
